import { useState } from "react";
import Icons from "../../Constants/Icon";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { i18n } = useTranslation();
    const handleChange = (e) => {
        const lang = e.target.value;

        i18n.changeLanguage(lang);
        const params = new URLSearchParams(location.search);
        params.set("lang", lang);

        navigate(`${location.pathname}?${params.toString()}`);
    };
    const lang = i18n.language;
    const addLang = (url) => `${url}?lang=${lang}`;
    return (
        <header className="app-header">
            <div className="container">
                <div className="header-bar">

                    <div className="flex-menu-block" >
                        <a className="desktop-menu" href={addLang("https://unityleases.ca/leaseyourspace")}>{t("Lease Your Space")}</a>
                        <a className="desktop-menu" href={addLang("https://unityleases.ca/findmylease")}>{t("Get Personalized Options")}</a>
                    </div>
                    <a href={addLang("https://unityleases.ca")} className="logo-center">
                        <img src={Icons.Ic_logo} alt="Logo" className="header-logo" />
                    </a>
                    <div className="flex-menu-block flex-menu-block-1" >
                        <a className="desktop-menu" href={addLang("https://unityleases.ca/contactus")}>{t("Contact Us")}</a>
                        <a className="desktop-menu" href={addLang("https://unityleases.ca/properties")}>{t("Available Rentals")}</a>
                    </div>

                    <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
                        <i className={menuOpen ? "fas fa-times" : "fas fa-bars"}></i>
                    </div>
                    <select className="Langchange" name="Langchange" onChange={handleChange} value={i18n.language}>
                        <option value="en">English</option>
                        <option value="fr">French</option>
                    </select>
                </div>


                {/* MOBILE MENU DROPDOWN */}
                <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
                    <a href={addLang("https://unityleases.ca/leaseyourspace")}>{t("Lease Your Space")}</a>
                    <a href={addLang("https://unityleases.ca/findmylease")}>{t("Get Personalized Options")}</a>
                    <a href={addLang("https://unityleases.ca/contactus")}>{t("Contact Us")}</a>
                    <a href={addLang("https://unityleases.ca/properties")}>{t("Available Rentals")}</a >
                </div>

            </div>
        </header>
    );
};

export default Header;
